export const scriptId = 'wistia_script';
